export default __webpack_public_path__ + "static/media/logoNIPEZ.023a0e7f.svg";